"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsSessions = void 0;
require("../../../../core");
const components_1 = require("../../../../components");
const getColumnsSessions = (t) => [
    {
        field: 'result',
        title: t('sessionsLogDialog|columns|sessions|result'),
        cell: components_1.statusCellRenderer(),
        sortable: true,
    },
    {
        field: 'creationTimeUtc',
        title: t('sessionsLogDialog|columns|sessions|start'),
        cell: components_1.datetimeCellRenderer(),
        sortable: true,
    },
    {
        field: 'endTimeUtc',
        title: t('sessionsLogDialog|columns|sessions|stop'),
        cell: components_1.datetimeCellRenderer(),
        sortable: true,
    },
    {
        field: 'duration',
        title: t('sessionsLogDialog|columns|sessions|duration'),
        cell: components_1.durationBetweenCellRenderer({
            startName: 'creationTimeUtc',
            stopName: 'endTimeUtc',
        }),
    },
];
exports.getColumnsSessions = getColumnsSessions;
//# sourceMappingURL=getColumnsSessions.js.map